// 強み評価
import { Serializable } from '@/models/core/serializable';

export class ExistStudentResponse implements Serializable<ExistStudentResponse> {
  exist: boolean = false;

  deserialize(input: any): ExistStudentResponse {
    this.exist = input.exist;

    return this;
  }
}
